import { router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    FullScreenSpinner,
    ScreenContainer,
    YStack,
} from 'smoothie';

import useGetCardWidgetUrl from '../../hooks/card/useGetCardWidgetUrl';
import { CardWidgetType } from '../../types/Card';
import CardWidget from './CardWidget';

const ChangePin = () => {
    const { chargeSecuredSyncteraAccountId, cardId } = useLocalSearchParams<{
        chargeSecuredSyncteraAccountId: string;
        cardId: string;
    }>();
    const { data, isLoading } = useGetCardWidgetUrl({
        syncteraAccountId: chargeSecuredSyncteraAccountId,
        cardId,
        widgetType: CardWidgetType.SET_PIN,
    });

    if (isLoading) {
        return <FullScreenSpinner />;
    }
    return (
        <ScreenContainer title="Change PIN" hasBackButton>
            <YStack justifyContent="center" $sm={{ alignItems: 'center' }}>
                <CardWidget url={data?.url as string} />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Done"
                    onPress={() => {
                        router.back();
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
};

export default ChangePin;
